/**
 * Firestore license doc + product-registration product id for this app.
 * Commerce pricing assumes `licensedProducts/{productId}.stripePriceIds` exists for this id.
 */
export const PRODUCT_ID = 'PIPHAUTHOR';
